import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJHistoryItem from '../view/FJHistoryItem.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setSliceSelectListAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJDropDownManager from '../../../../common/js/FJDropDownManager.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import PropTypes from 'prop-types';
import FJConstant from '../../../../constants/FJConstant.js';
import FJActionTextToSpeechProject from '../../../../redux/action/FJActionTextToSpeechProject.js';
import FJUtil from '../../../../util/FJUtil.js';
const FJHistoryItemContainer = props => {
    useLocalStore();
    const dispatch = useDispatch();
    const { info } = props;
    const { default_content: desc, created_at: createTime, pid } = info;

    const isMultipleMode = useSelector(state => state.common.isMultipleMode);
    const selectList = useSelector(state => state.common.selectList);
    const selected = !!selectList?.find(i => i === pid);

    const _onEdit = () => {
        FJUtil.eaLog('history_edit_click');
        dispatch(FJActionTextToSpeechProject.onEditAction(pid));
    };

    const _onDownload = () => {
        FJUtil.eaLog('speech_download_click', { position: 'history' });
        dispatch(FJActionTextToSpeechProject.onDownloadByPidAction(pid));
    };

    const _enterMultiple = () => {
        FJDropDownManager.hideAll();
        dispatch(FJActionCommon.setIsMultipleModeAction(true));
        dispatch(setSliceSelectListAction([pid]));
    };
    const _onSelect = (bool = true) => {
        if (bool) {
            dispatch(setSliceSelectListAction([...selectList, pid]));
        } else {
            dispatch(setSliceSelectListAction(selectList.filter(i => i !== pid)));
        }
    };

    const _onDelete = () => {
        FJDropDownManager.hideAll();
        dispatch(FJActionCommon.multiDeleteAction([pid], undefined, { type: FJConstant.TEXT_TO_SPEECH }));
    };

    const _onPreview = () => {
        if (isMultipleMode) {
            _onSelect(!selected);
            return;
        }
        dispatch(FJActionTextToSpeechProject.openTTVProjectModalAction(pid));
    };

    return (
        <FJHistoryItem
            desc={desc}
            createTime={createTime}
            onEdit={_onEdit}
            onDownload={_onDownload}
            onSelect={_onSelect}
            onDelete={_onDelete}
            enterMultiple={_enterMultiple}
            isSelected={selected}
            isMultipleMode={isMultipleMode}
            onPreview={_onPreview}
        />
    );
};

FJHistoryItemContainer.propTypes = {
    info: PropTypes.object,
};
export default FJHistoryItemContainer;
